import {Messages} from '../../constants';

const validation = {
  tipo: {
    presence: {
      message: Messages.RequiredTypeProfessionValidationMessage,
      allowEmpty: false,
    },
  },
  nome: {
    presence: {
      message: Messages.RequiredProfessionValidationMessage,
      allowEmpty: false,
    },
  },
  empresa: {
    presence: {
      message: Messages.RequiredCompanyValidationMessage,
      allowEmpty: false,
    },
  },
  telefone: function (value) {
    if (value) {
      let valueFormatted = value.replace(/[^0-9.]/g, '');
      if (valueFormatted.length < 10) {
        return {
          phone: {
            message: Messages.TelephoneIncorrectMessage,
          },
        };
      }
      if (/\b(\d)\1+\b/g.test(valueFormatted)) {
        return {
          phone: {
            message: Messages.TelephoneIncorrectMessage,
          },
        };
      }
    }
  },
  admissao: {
    presence: {
      message: Messages.RequiredDateAdmissionValidationMessage,
      allowEmpty: false,
    },
    brDate: {
      message: Messages.InvalidAdmissionDateMessage,
    },
    lowestCurrentDate: {
      message: Messages.LowestCurrentDateAdmissionValidationMessage,
    },
  },
  rendaMensal: {
    presence: {
      message: Messages.RequiredMonthlyIncomeValidationMessage,
      allowEmpty: false,
    },
  },
};

export default validation;
